import { types } from '../../../constants/ActionTypes'
import { deepCopy } from '../../../lib'

const initialState = {
  open: false,
  boardImage: '',
  url: '',
  shortURL: '',
  text: '',
  defaultText: '',
  hashtags: [],
  datetime: 0,
  checkedImage: false,
  checkedSchedule: false,
  validTweet: false,
  remainingLength: 0,
  isFetching: false,
  isCompleted: false,
}

const tweetDialog = (state = initialState, action) => {
  var ret, text, remainingLength, validTweet
  switch (action.type) {
    case types.tweetDialog.OPEN:
      return { ...deepCopy(initialState), open: true }
    case types.tweetDialog.CLOSE:
      return { ...state, open: false }
    case types.tweetDialog.CHANGED_CHECKBOX:
      return { ...state, [action.name]: action.checked }
    case types.tweetDialog.CHANGED_TEXT:
      if (action.name === 'text') {
        ret = action.twitterText.parseTweet(action.text)
        remainingLength = 280 - ret.weightedLength
        validTweet = ret.valid
        return { ...state, [action.name]: action.text, remainingLength, validTweet }
      }
      return { ...state, [action.name]: action.text }
    case types.tweetDialog.MAKED_URL:
      return { ...state, url: action.url }
    case types.tweetDialog.DEFAULT_TEXT:
      return { ...state, defaultText: action.text }
    case types.tweetDialog.CHANGED_HASHTAGS:
      return { ...state, hashtags: action.tags }
    case types.bitly.RECEIVE_MAKE_SHORT_URL:
      if (state.open === false || !action.response.link){
        return { ...state, shortURL: 'invalid' }
      }
      let tagStr
      tagStr = '#RenjuPortal'
      if (state.hashtags.length > 0) {
        state.hashtags.forEach((tag) => {
          tagStr += `\n#${tag}`
        })
      }
      text = `${state.defaultText}\n${action.response.link}\n${tagStr}`
      ret = action.twitterText.parseTweet(text)
      remainingLength = 280 - ret.weightedLength
      validTweet = ret.valid
      return { ...state, shortURL: action.response.link, text, remainingLength, validTweet}
    case types.lib.RESPONSE_CREATE_BOARD_IMAGE:
      if (state.open === false) {
        return state
      }
      return { ...state, boardImage: action.boardImage }
    case types.twitter.REQUEST_TWEET:
      return { ...state, isFetching: true }
    case types.twitter.RECEIVE_TWEET:
      if (action.response.result === false || state.isFetching === false) {
        return state
      }
      return { ...state, open: false, isFetching: false, isCompleted: true }
    default:
      return state
  }
}

export default tweetDialog



// WEBPACK FOOTER //
// ./src/reducers/Common/RenjuBoardCard/TweetDialog.js